// extracted by mini-css-extract-plugin
module.exports = {"advantage":"Advantage_advantage__hivTl","advantage__text":"Advantage_advantage__text__A5t_T"};